import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("admin_token");
            window.location.href = "/admin"; // /admin/login → /admin
        }
        return Promise.reject(err);
    },
);

// ── Public ──────────────────────────────────────────────
export const fetchTournamentInfo = () => api.get("/api/players/tournament");
export const fetchTeams = () => api.get("/api/players/teams");
export const fetchTeamLogoUrl = (id) =>
    api.get(`/api/players/teams/${id}/logo`);
export const checkJersey = (team_id, jersey_number) =>
    api.get("/api/players/check-jersey", {
        params: { team_id, jersey_number },
    });
export const checkEmail = (email) =>
    api.get("/api/players/check-email", { params: { email } });
export const registerPlayer = (data) => api.post("/api/players/register", data);
export const updatePlayerFiles = (id, urls) =>
    api.patch(`/api/players/${id}/files`, urls);
export const checkPlayerStatus = (id) => api.get(`/api/players/status/${id}`);

// File upload (multipart)
export const uploadFile = (file, type, meta = {}) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("type", type);
    if (meta.team_id != null) fd.append("team_id", meta.team_id);
    if (meta.team_name) fd.append("team_name", meta.team_name);
    if (meta.player_id != null) fd.append("player_id", meta.player_id);
    if (meta.player_name) fd.append("player_name", meta.player_name);
    return api.post("/api/players/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const getPlayerFileUrl = (player_id, type) =>
    api.get(`/api/admin/players/${player_id}/file-url`, { params: { type } });

export const fetchPlayerCard = (player_id) =>
    api.get(`/api/admin/players/${player_id}/card`);

export const savePlayerCard = (player_id, image) =>
    api.post(`/api/admin/players/${player_id}/card`, { image });

export const fetchPlayerCardImage = (player_id) =>
    api.get(`/api/admin/players/${player_id}/card-image`);

export const exportAllCards = (params) =>
    api.get("/api/admin/cards/export", { params, responseType: "blob" });

// ── Payments ─────────────────────────────────────────────
export const fetchPaymentConfig = () => api.get("/api/payments/config");
export const createStripeIntent = (email, player_id) =>
    api.post("/api/payments/stripe/create-intent", { email, player_id });
export const createPayPalOrder = () =>
    api.post("/api/payments/paypal/create-order");
export const capturePayPalOrder = (order_id) =>
    api.post("/api/payments/paypal/capture", { order_id });
export const confirmPayment = (player_id, payment_method, payment_ref) =>
    api.post("/api/payments/confirm", {
        player_id,
        payment_method,
        payment_ref,
    });

// ── Admin ───────────────────────────────────────────────
export const adminLogin = (username, password) =>
    api.post("/api/auth/login", { username, password });

export const fetchStats = () => api.get("/api/admin/stats");
export const fetchPlayers = (params) =>
    api.get("/api/admin/players", { params });
export const approvePlayer = (id) =>
    api.post(`/api/admin/players/${id}/approve`);
export const rejectPlayer = (id, note) =>
    api.post(`/api/admin/players/${id}/reject`, { note });
export const deletePlayer = (id) => api.delete(`/api/admin/players/${id}`);

export const fetchAdminTeams = () => api.get("/api/admin/teams");
export const createTeam = (data) => api.post("/api/admin/teams", data);
export const updateTeam = (id, data) => api.put(`/api/admin/teams/${id}`, data);
export const deleteTeam = (id) => api.delete(`/api/admin/teams/${id}`);

export const fetchTournamentSettings = () => api.get("/api/admin/tournament");
export const updateTournamentSettings = (data) =>
    api.put("/api/admin/tournament", data);

export const exportPlayers = (params) => {
    const token = localStorage.getItem("admin_token");
    const qs = new URLSearchParams(params).toString();
    window.open(
        `${api.defaults.baseURL}/api/admin/export/players?${qs}`,
        "_blank",
    );
};

export default api;
